import isObject from 'lodash/isObject';

export const pascalCase = (str) =>
    str
        .replace(/[^a-z0-9]+/gi, ' ')
        .replace(/(\w)(\w*)/g, (g0, g1, g2) => `${g1.toUpperCase()}${g2.toLowerCase()}`)
        .replace(/\s+/gi, '');

export const isMessage = (message) => isObject(message) && typeof message.id !== 'undefined';

export const getComponentFromName = (name, components, defaultComponent = null) => {
    const componentName = pascalCase(name);
    return components[componentName] || defaultComponent;
};

const string2hex = (string) => {
    if (typeof string === 'string') {
        // string = (cssColorNames as {[key: string]: string})[string.toLowerCase()] || string;
        if (string[0] === '#') {
            string = string.substr(1);
        }
    }
    return parseInt(string, 16);
};

export function hexToRGB(color, output) {
    if (!output) {
        output = {};
    }

    if (color.charAt(0) === '#') {
        color = color.substr(1);
    } else if (color.indexOf('0x') === 0) {
        color = color.substr(2);
    }
    let alpha;

    if (color.length === 8) {
        alpha = color.substr(0, 2);
        color = color.substr(2);
    }

    output.r = parseInt(color.substr(0, 2), 16); // Red
    output.g = parseInt(color.substr(2, 2), 16); // Green
    output.b = parseInt(color.substr(4, 2), 16); // Blue

    if (alpha) {
        output.a = parseInt(alpha, 16);
    }

    return output;
}

function componentToHex(c) {
    var hex = Math.round(c).toString(16);
    return hex.length == 1 ? '0' + hex : hex;
}

function rgbToHex({ r, g, b }) {
    return string2hex(`#${componentToHex(r)}${componentToHex(g)}${componentToHex(b)}`);
}

export function createSteppedGradient(list = [], numSteps = 10) {
    if (typeof numSteps !== 'number' || numSteps <= 0) {
        numSteps = 10;
    }
    const items = [];
    const first = { value: hexToRGB(list[0].value), time: list[0].time };

    first.isStepped = true;
    let currentNode = first;
    let current = list[0];
    let nextIndex = 1;
    let next = list[nextIndex];

    for (let i = 1; i < numSteps; ++i) {
        let lerp = i / numSteps;
        // ensure we are on the right segment, if multiple

        while (lerp > next.time) {
            current = next;
            next = list[++nextIndex];
        }
        // convert the lerp value to the segment range
        lerp = (lerp - current.time) / (next.time - current.time);
        const curVal = hexToRGB(current.value);
        const nextVal = hexToRGB(next.value);
        const output = {
            r: (nextVal.r - curVal.r) * lerp + curVal.r,
            g: (nextVal.g - curVal.g) * lerp + curVal.g,
            b: (nextVal.b - curVal.b) * lerp + curVal.b,
        };

        currentNode.next = { value: output, time: i / numSteps };
        currentNode = currentNode.next;

        // console.log('rgbToHex(output)', output, rgbToHex(output));

        items.push({ value: rgbToHex(output), time: i / numSteps });
    }

    // we don't need to have a PropertyNode for time of 1, because in a stepped version at that point
    // the particle has died of old age
    return items;
}

export function randomNormal() {
    let u = 0,
        v = 0;
    while (u === 0) u = Math.random(); //Converting [0,1) to (0,1)
    while (v === 0) v = Math.random();
    let num = Math.sqrt(-2.0 * Math.log(u)) * Math.cos(2.0 * Math.PI * v);
    num = num / 10.0 + 0.5; // Translate to 0 -> 1
    if (num > 1 || num < 0) return randomNormal(); // resample between 0 and 1
    return num;
}

export const toBase64 = (file) =>
    new Promise((resolve, reject) => {
        const reader = new FileReader();
        reader.readAsDataURL(file);
        reader.onload = () => resolve(reader.result);
        reader.onerror = reject;
    });

export function assertFileValid(file) {
    const allowedTypes = ['image/webp', 'image/jpeg', 'image/png'];
    const sizeLimit = 1024 * 1024 * 10 * 10; // 10 megabytes
    const { name: fileName, size: fileSize } = file;
    if (!allowedTypes.includes(file.type)) {
        console.log(
            `File "${fileName}" could not be uploaded. Only images with the following types are allowed: WEBP, JPEG, PNG.`,
        );
        return false;
    }
    if (fileSize > sizeLimit) {
        console.log(
            `File "${fileName}" could not be uploaded. Only images up to 1 MB are allowed.`,
        );
        return false;
    }
    return true;
}

export const getImageSize = (image) =>
    new Promise((resolve) => {
        const img = new Image();
        img.onload = () => {
            resolve({ width: img.width, height: img.height });
        };
        img.src = image;
    });
